import classNames from 'classnames';
import React from 'react';
import { useMatchMedia } from '@udemy/hooks';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Button, Picture } from '@udemy/react-core-components';
import { safelySetInnerHTML } from '@udemy/shared-utils';
import { tokens } from '@udemy/styles';
import { HeroBannerSlideLayoutType } from './hero-banner-slide.react-component';
import styles from "./wide-hero-banner-slide.module.css";
export const WideHeroBannerSlide = ({
  button1Href,
  button1OnClick,
  button1Text,
  button1Target = '_self',
  button2Href,
  button2OnClick,
  button2Text,
  button2Target = '_blank',
  image,
  imageResponsive,
  showSearchBar = true,
  slideLayout,
  subtitle,
  title,
  url,
  subtitleOnClick,
  urlOnClick,
  typography,
  className
}) => {
  var _typography$title, _typography$subtitle;
  const imageWideSource = {
    srcSet: imageResponsive.src,
    width: imageResponsive.width,
    height: imageResponsive.height,
    media: `(max-width: ${tokens['breakpoint-sm-max']})`
  };
  const {
    gettext
  } = useI18n();
  const isSmMax = useMatchMedia('sm-max');
  const bannerImage = /*#__PURE__*/React.createElement(Picture, Object.assign({}, image, {
    sources: [imageWideSource]
  }));
  const isWideDarkLayout = slideLayout === HeroBannerSlideLayoutType.WIDE_DARK;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.banner, {
      [styles['banner-dark']]: isWideDarkLayout
    }, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['image-container']
  }, url && !(button1Href && button1Text) ? /*#__PURE__*/React.createElement("a", {
    href: url,
    onClick: e => urlOnClick === null || urlOnClick === void 0 ? void 0 : urlOnClick(e, 'slide')
  }, bannerImage) : bannerImage), /*#__PURE__*/React.createElement("div", {
    className: styles['content-box']
  }, /*#__PURE__*/React.createElement("h1", Object.assign({
    className: classNames('ud-heading-serif-xxl', (_typography$title = typography === null || typography === void 0 ? void 0 : typography.title) !== null && _typography$title !== void 0 ? _typography$title : '')
  }, safelySetInnerHTML({
    descriptionOfCaller: 'billboard:title',
    html: title,
    domPurifyConfig: {
      ADD_ATTR: ['target']
    }
  }))), /*#__PURE__*/React.createElement("p", Object.assign({
    onClick: e => subtitleOnClick === null || subtitleOnClick === void 0 ? void 0 : subtitleOnClick(e, 'text'),
    className: classNames('ud-text-md', (_typography$subtitle = typography === null || typography === void 0 ? void 0 : typography.subtitle) !== null && _typography$subtitle !== void 0 ? _typography$subtitle : '')
  }, safelySetInnerHTML({
    descriptionOfCaller: 'billboard:subtitle',
    html: subtitle,
    domPurifyConfig: {
      ADD_ATTR: ['target']
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['cta-buttons-container']
  }, button1Href && button1Text && /*#__PURE__*/React.createElement(Button, Object.assign({
    id: "banner-cta-primary",
    udStyle: "primary",
    size: "large",
    componentClass: "a",
    typography: "ud-heading-md",
    href: button1Href,
    onClick: button1OnClick,
    target: button1Target,
    className: styles['cta-1']
  }, button1Target === '_blank' && {
    rel: 'noopener'
  }), button1Text), button2Href && button2Text && /*#__PURE__*/React.createElement(Button, Object.assign({
    id: "banner-cta-secondary",
    udStyle: "secondary",
    size: "large",
    componentClass: "a",
    typography: "ud-heading-md",
    href: button2Href,
    onClick: button2OnClick,
    target: button2Target,
    className: styles['cta-2']
  }, button2Target === '_blank' && {
    rel: 'noopener'
  }), button2Text)), showSearchBar && isSmMax && /*#__PURE__*/React.createElement("div", {
    className: styles['search-bar-container']
  }, /*#__PURE__*/React.createElement(Button, {
    id: "mobile-billboard-open-search-button",
    cssToggleId: "header-toggle-search-bar",
    size: "large",
    udStyle: "ghost",
    typography: "ud-text-md",
    className: styles['search-bar-button']
  }, /*#__PURE__*/React.createElement("span", {
    id: "mobile-billboard-open-search-text"
  }, gettext('What do you want to learn?')), /*#__PURE__*/React.createElement(Icon, {
    glyph: "search",
    id: "mobile-billboard-open-search-icon",
    size: "medium",
    color: "neutral",
    label: false
  })))));
};
//# sourceMappingURL=wide-hero-banner-slide.react-component.js.map